/**
 * Premium Card Swatches — Allbirds-style interaction
 *
 * Handles swatch image swapping, subtitle updates, size availability,
 * and AJAX add-to-cart submissions.
 *
 * Runs once globally via a DOMContentLoaded guard.
 */
(function () {
  if (window.__premiumCardSwatchInit) return;
  window.__premiumCardSwatchInit = true;

  /** Cross-fade duration in ms — matches CSS transition timing */
  var FADE_MS = 150;



  /**
   * Initialize swatch and size interactions for a single card element.
   * @param {HTMLElement} card
   */
  function initCard(card) {
    var swatches = card.querySelectorAll('.premium-card__swatch');
    var mainImage = card.querySelector('.premium-card__image');
    if (!mainImage) return;

    var activeSwatchName = card.querySelector('.premium-card__active-swatch-name');
    var originalSwatchName = activeSwatchName ? activeSwatchName.textContent : '';

    /* Store the original image src for reset */
    var originalSrc = mainImage.src;
    var originalSrcset = mainImage.srcset || '';

    // Slide Reveal Trigger Logic
    var revealTrigger = card.querySelector('.premium-card__mobile-action-trigger');
    if (revealTrigger) {
      revealTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var revealWrapper = card.querySelector('.premium-card__mobile-actions--slide-reveal');
        if (revealWrapper) {
          revealWrapper.classList.toggle('is-revealed');
          
          // Optional: close other revealed cards
          document.querySelectorAll('.premium-card__mobile-actions--slide-reveal.is-revealed').forEach(function(el) {
            if (el !== revealWrapper) {
              el.classList.remove('is-revealed');
            }
          });
        }
      });
    }

    // Parse variants JSON map
    var variantsJsonEl = card.querySelector('.premium-card__variants-json');
    var variantsData = {};
    if (variantsJsonEl) {
      try {
        variantsData = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        console.error('Failed to parse card variants JSON:', e);
      }
    }

    var swatchIndex = parseInt(card.dataset.swatchOptionIndex);
    var sizeIndex = parseInt(card.dataset.sizeOptionIndex);
    var totalOptions = parseInt(card.dataset.totalOptions);

    /**
     * Find a variant matching a swatch and size value
     * @param {string} swatchVal
     * @param {string} sizeVal
     */
    function findVariant(swatchVal, sizeVal) {
      var optionValues = new Array(totalOptions);
      if (swatchIndex !== -1) optionValues[swatchIndex] = swatchVal;
      if (sizeIndex !== -1) optionValues[sizeIndex] = sizeVal;
      var key = optionValues.join('___');
      
      if (variantsData[key]) {
        return variantsData[key];
      }

      // Fallback: search all variants for matching option indices
      for (var k in variantsData) {
        var parts = k.split('___');
        var match = true;
        if (swatchIndex !== -1 && parts[swatchIndex] !== swatchVal) match = false;
        if (sizeIndex !== -1 && parts[sizeIndex] !== sizeVal) match = false;
        if (match) return variantsData[k];
      }
      return null;
    }

    /**
     * Update size buttons disabled/sold-out state based on active swatch
     */
    function updateSizeButtonsState() {
      var sizeButtons = card.querySelectorAll('.premium-card__size-btn');
      var activeSwatch = card.querySelector('.premium-card__swatch.active');
      var activeSwatchValue = activeSwatch ? activeSwatch.dataset.value : '';

      sizeButtons.forEach(function (btn) {
        var sizeValue = btn.dataset.sizeValue;
        var variant = findVariant(activeSwatchValue, sizeValue);
        
        if (variant && variant.available) {
          btn.removeAttribute('disabled');
          btn.classList.remove('sold-out');
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.classList.add('sold-out');
        }
      });
    }

    // Set up MutationObserver to sync loading state from hidden submit button
    var productForm = card.querySelector('product-form');
    var lastClickedBtn = null;
    if (productForm) {
      var hiddenSubmitBtn = productForm.querySelector('[type="submit"]');
      if (hiddenSubmitBtn) {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class' && lastClickedBtn) {
              var isLoading = hiddenSubmitBtn.classList.contains('loading');
              if (isLoading) {
                lastClickedBtn.classList.add('loading');
                lastClickedBtn.setAttribute('disabled', 'disabled');
              } else {
                lastClickedBtn.classList.remove('loading');
                lastClickedBtn.removeAttribute('disabled');
                lastClickedBtn = null;
              }
            }
          });
        });
        observer.observe(hiddenSubmitBtn, { attributes: true });
      }
    }

    // Size button clicks
    var sizeButtons = card.querySelectorAll('.premium-card__size-btn');
    var sizeSubmitBtn = card.querySelector('.premium-card__size-submit-btn');
    var selectedVariant = null;

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('sold-out') || btn.hasAttribute('disabled') || btn.classList.contains('loading')) return;

        sizeButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var activeSwatch = card.querySelector('.premium-card__swatch.active');
        var activeSwatchValue = activeSwatch ? activeSwatch.dataset.value : '';
        var sizeValue = btn.dataset.sizeValue;
        selectedVariant = findVariant(activeSwatchValue, sizeValue);

        if (selectedVariant) {
          var titleEl = card.querySelector('.premium-card__title a');
          var title = titleEl ? titleEl.textContent.trim() : '';
          var productUrl = titleEl ? titleEl.getAttribute('href') : '';
          
          var imgEl = card.querySelector('.premium-card__image');
          var imageSrc = imgEl ? (imgEl.getAttribute('srcset') ? imgEl.getAttribute('srcset').split(' ')[0] : imgEl.getAttribute('src')) : '';
          
          var waBtn = card.querySelector('[data-mobile-card-whatsapp]');
          var waPhone = waBtn ? waBtn.getAttribute('data-whatsapp-phone') : '918148936699';

          openPersonalizationDrawer(title, btn.textContent.trim(), imageSrc, productUrl, waPhone);
        }
      });
    });

    if (sizeSubmitBtn) {
      sizeSubmitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (sizeSubmitBtn.hasAttribute('disabled') || sizeSubmitBtn.classList.contains('loading')) return;

        if (selectedVariant && productForm) {
          var input = productForm.querySelector('[name="id"]');
          var submit = productForm.querySelector('[type="submit"]');
          if (input && submit) {
            input.value = selectedVariant.id;
            lastClickedBtn = sizeSubmitBtn;
            var formEl = productForm.querySelector('form');
            if (formEl) {
              if (typeof formEl.requestSubmit === 'function') {
                formEl.requestSubmit();
              } else {
                formEl.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
              }
            }
          }
        }
      });
    }

    // Single Add to Cart button click
    var singleAddBtn = card.querySelector('.premium-card__quick-add-btn-single');
    if (singleAddBtn) {
      singleAddBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (singleAddBtn.hasAttribute('disabled') || singleAddBtn.classList.contains('loading')) return;

        var activeSwatch = card.querySelector('.premium-card__swatch.active');
        var activeSwatchValue = activeSwatch ? activeSwatch.dataset.value : '';
        var variant = findVariant(activeSwatchValue, '');

        if (!variant) {
          // If no swatch active, just use the first available variant
          for (var k in variantsData) {
            if (variantsData[k].available) {
              variant = variantsData[k];
              break;
            }
          }
        }

        if (variant && productForm) {
          var input = productForm.querySelector('[name="id"]');
          var submit = productForm.querySelector('[type="submit"]');
          if (input && submit) {
            input.value = variant.id;
            lastClickedBtn = singleAddBtn;
            var formEl = productForm.querySelector('form');
            if (formEl) {
              if (typeof formEl.requestSubmit === 'function') {
                formEl.requestSubmit();
              } else {
                formEl.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
              }
            }
          }
        }
      });
    }

    // Initialize size buttons on load
    updateSizeButtonsState();

    // Helper to open the personalization drawer
    function openPersonalizationDrawer(title, size, imageSrc, productUrl, waPhone) {
      var wrapper = document.getElementById('PersonalizationDrawer-Wrapper');
      var drawer = document.getElementById('PersonalizationDrawer');
      if (!wrapper || !drawer) return;

      var titleEl = document.getElementById('PersonalizationDrawer-ProductTitle');
      if (titleEl) titleEl.textContent = title;

      var sizeEl = document.getElementById('PersonalizationDrawer-ProductSize');
      if (sizeEl) sizeEl.textContent = size;

      var imgEl = document.getElementById('PersonalizationDrawer-ProductImage');
      if (imgEl) imgEl.src = imageSrc;

      var ctaEl = document.getElementById('PersonalizationDrawer-CTA');
      if (ctaEl) {
        var msg = "Hi, I'm interested in personalizing the " + title + " (Size: " + size + "). I found it here: " + window.location.origin + productUrl;
        var waUrl = "https://wa.me/" + waPhone.replace(/[^0-9]/g, '') + "?text=" + encodeURIComponent(msg);
        ctaEl.href = waUrl;
      }

      wrapper.style.visibility = 'visible';
      document.body.classList.add('overflow-hidden');
      setTimeout(function() {
        drawer.style.transform = 'translateX(0)';
      }, 50);
    }

    // Swatches listeners
    swatches.forEach(function (swatch) {
      /* Hover: swap image, name, and update size buttons */
      swatch.addEventListener('mouseenter', function () {
        var newSrc = swatch.dataset.image;
        if (!newSrc) return;

        /* Mark active swatch */
        swatches.forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        if (activeSwatchName) {
          activeSwatchName.textContent = swatch.getAttribute('title') || swatch.getAttribute('aria-label');
        }

        updateSizeButtonsState();

        // Reset size selection on swatch change
        sizeButtons.forEach(function (b) { b.classList.remove('active'); });
        if (sizeSubmitBtn) sizeSubmitBtn.style.display = 'none';
        selectedVariant = null;

        /* Cross-fade */
        mainImage.style.opacity = '0.6';
        setTimeout(function () {
          mainImage.src = newSrc;
          mainImage.removeAttribute('srcset');
          mainImage.style.opacity = '1';
        }, FADE_MS);
      });

      /* Click: same behavior + updates original values (for mobile tap & locking active state) */
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var newSrc = swatch.dataset.image;
        if (!newSrc) return;

        swatches.forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        var newName = swatch.getAttribute('title') || swatch.getAttribute('aria-label');
        if (activeSwatchName) {
          activeSwatchName.textContent = newName;
          originalSwatchName = newName; // Lock clicked swatch name
        }

        originalSrc = newSrc; // Lock clicked image src
        originalSrcset = '';  // Clear original srcset so clicked image stays active

        updateSizeButtonsState();

        // Reset size selection on swatch click
        sizeButtons.forEach(function (b) { b.classList.remove('active'); });
        if (sizeSubmitBtn) sizeSubmitBtn.style.display = 'none';
        selectedVariant = null;

        mainImage.style.opacity = '0.6';
        setTimeout(function () {
          mainImage.src = newSrc;
          mainImage.removeAttribute('srcset');
          mainImage.style.opacity = '1';
        }, FADE_MS);
      });
    });

    /* Reset on mouse leaving the swatch area */
    var swatchContainer = card.querySelector('.premium-card__swatches');
    if (swatchContainer) {
      swatchContainer.addEventListener('mouseleave', function () {
        /* Reset to current active swatch */
        var activeSwatch = swatchContainer.querySelector('.premium-card__swatch.active');
        if (activeSwatch) {
          swatches.forEach(function (s) { s.classList.remove('active'); });
          activeSwatch.classList.add('active');

          if (activeSwatchName) {
            activeSwatchName.textContent = originalSwatchName;
          }

          updateSizeButtonsState();

          mainImage.style.opacity = '0.6';
          setTimeout(function () {
            mainImage.src = originalSrc;
            if (originalSrcset) {
              mainImage.srcset = originalSrcset;
            } else {
              mainImage.removeAttribute('srcset');
            }
            mainImage.style.opacity = '1';
          }, FADE_MS);
        }
      });
    }
  }

  /**
   * Initialize all premium cards on the page.
   */
  function initAll() {
    document.querySelectorAll('.premium-card').forEach(initCard);
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init after Shopify AJAX section rendering (e.g. Quick Add, pagination) */
  document.addEventListener('shopify:section:load', initAll);
})();
